var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-view"},[_c('div',{staticClass:"title"},[_vm._v("Welcome")]),_c('div',{staticClass:"desc"},[_vm._v("首页即将上线，敬请期待")])])}]

export { render, staticRenderFns }